function required(name: keyof ImportMetaEnv): string {
  const v = import.meta.env[name];
  if (!v) {
    throw new Error(
      `Missing ${name}. Copy apps/spa/.env.example to .env.local and fill it in; VITE_* values are baked in at build time.`,
    );
  }
  return String(v).replace(/\/+$/, '');
}

export const appConfig = {
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabaseAnonKey: String(import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''),
  /** MCP server base URL; it also serves /rpc and /integrations. */
  apiUrl: required('VITE_API_URL'),
  /** Static customer-facing capability pages. */
  publicSiteUrl: String(
    import.meta.env.VITE_PUBLIC_SITE_URL ?? 'https://phinest.app',
  ).replace(/\/+$/, ''),
};

if (!appConfig.supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY.');
}
